<template>
  <div
    v-if="showing"
    class="nt-customresult"
  >
    <div class="nt-customresult__content">
      <slot />
    </div>
    <div class="nt-customresult__actions">
      <div>
        <slot name="callUrlAction" />
      </div>
      <div @click="onClickToBack">
        <slot name="backAction" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import emitter from 'tiny-emitter/instance'

export default {
  name: 'nt-customresult',
  props: {
    id: {
      type: String
    },
    bykey: {
      type: String
    },
    byvalue: {
      type: String
    }
  },
  setup() {
    const showing = (val) => {
      emitter.emit('showCustomResult', val)
    }

    return { showing }
  },
  created() {
    emitter.on('changeForm', (data) => {
      const key = _.keys(data)[0]
      let value = _.values(data)[0]

      if (value) {
        value = value.toString()
      }

      this.showing = key === this.bykey && value === this.byvalue
    })
  },
  methods: {
    onClickToBack() {
      this.showing = !this.showing
    }
  }
}
</script>

<style lang="scss" scoped>
  .nt-customresult {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    padding: 10% 0;

    & > div:not(:last-of-type)  {
      margin-bottom: 6%;
    }

    &__content {
      max-width: 50rem;
    }

    &__actions {
      display: flex;

      & > *:not(:last-child) {
        margin-right: 0.625rem
      }
    }
  }
</style>
